// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu__container___haMsE","isGroup":"Menu__isGroup___8ilQx","list":"Menu__list___7zPGI","item":"Menu__item___KRieE ContextMenuItem__container___FLNIE"};